import React from 'react';
import { Hero } from '../components/home/Hero';
import { FeatureStrip } from '../components/home/FeatureStrip';
import { TheMaskSection } from '../components/home/TheMaskSection';
import { WavelengthStory } from '../components/home/WavelengthStory';
import { LightScience } from '../components/home/LightScience';
import { ScrollStory } from '../components/home/ScrollStory';
import { KitSection } from '../components/home/KitSection';
import { ProductDetails } from '../components/home/ProductDetails';
import { FaqSection } from '../components/home/FaqSection';
import { ClosingInvitation } from '../components/home/ClosingInvitation';
export function Home() {
  return <>
      <Hero data-id="element-541" data-mp="2dhywio1gjitm" />
      <FeatureStrip data-id="element-542" data-mp="2dirsctyvonwz" />
      <TheMaskSection data-id="element-543" data-mp="2dj1m8sn1nf7y" />
      <WavelengthStory data-id="element-544" data-mp="2dfdthvpfawua" />
      <LightScience data-id="element-545" data-mp="3kvtl5drznpxf" />
      <ScrollStory data-id="element-546" data-mp="3ku8tbvx26l39" />
      <KitSection data-id="element-547" data-mp="3kv0nd2b0carf" />
      <ProductDetails data-id="element-548" data-mp="3kxmtcxi92i7j" />
      <FaqSection data-id="element-549" data-mp="3owlyoj7w8gzi" />
      <ClosingInvitation data-id="element-550" data-mp="3ovub9vog9pkb" />
    </>;
}